// value is in seconds
export const CLIENT_SN_DURATION_OPTIONS = [
  {
    value: 900,
    label: '0:15 hr',
  },
  {
    value: 1800,
    label: '0:30 hr',
  },
  {
    value: 2700,
    label: '0:45 hr',
  },
  {
    value: 3600,
    label: '1:00 hr',
  },
  {
    value: 4500,
    label: '1:15 hr',
  },
  {
    value: 5400,
    label: '1:30 hr',
  },
  {
    value: 6300,
    label: '1:45 hr',
  },
  {
    value: 7200,
    label: '2:00 hr',
  },
  {
    value: 8100,
    label: '2:15 hr',
  },
  {
    value: 9000,
    label: '2:30 hr',
  },
  {
    value: 9900,
    label: '2:45 hr',
  },
  {
    value: 10800,
    label: '3:00 hr',
  },
  {
    value: 11700,
    label: '3:15 hr',
  },
  {
    value: 12600,
    label: '3:30 hr',
  },
  {
    value: 13500,
    label: '3:45 hr',
  },
  {
    value: 14400,
    label: '4:00 hr',
  },
];

export const PARENT_SN_DURATION_OPTIONS = [
  {
    value: 900,
    label: '0:15 hr',
  },
  {
    value: 1800,
    label: '0:30 hr',
  },
  {
    value: 2700,
    label: '0:45 hr',
  },
  {
    value: 3600,
    label: '1:00 hr',
  },
  {
    value: 4500,
    label: '1:15 hr',
  },
  {
    value: 5400,
    label: '1:30 hr',
  },
  {
    value: 6300,
    label: '1:45 hr',
  },
  {
    value: 7200,
    label: '2:00 hr',
  },
];

export const BT_SN_DURATION_OPTIONS = [
  {
    value: 1800,
    label: '0:30 hr',
  },
  {
    value: 2700,
    label: '0:45 hr',
  },
  {
    value: 3600,
    label: '1:00 hr',
  },
  {
    value: 4500,
    label: '1:15 hr',
  },
  {
    value: 5400,
    label: '1:30 hr',
  },
  {
    value: 6300,
    label: '1:45 hr',
  },
  {
    value: 7200,
    label: '2:00 hr',
  },
];

export const GROUP_SN_DURATION_OPTIONS = [
  {
    value: 1800,
    label: '0:30 hr',
  },
  {
    value: 2700,
    label: '0:45 hr',
  },
  {
    value: 3600,
    label: '1:00 hr',
  },
  {
    value: 4500,
    label: '1:15 hr',
  },
  {
    value: 5400,
    label: '1:30 hr',
  },
  {
    value: 6300,
    label: '1:45 hr',
  },
  {
    value: 7200,
    label: '2:00 hr',
  },
];

export enum AttendanceType {
  Full = 'Full',
  Partial = 'Partial',
  Correction = 'Needs Review',
}

export const SUPERVISION_LOCATIONS = [
  { value: 'HOME', label: 'Home' },
  { value: 'COMMUNITY', label: 'Community' },
  { value: 'TELEHEALTH', label: 'Telehealth' },
];

export const SUPERVISION_SETTINGS = [
  { value: 'Remote', label: 'Remote' },
  { value: 'In-person', label: 'In-person' },
];

export const SUPERVISION_LOCATION_V2 = [
  { value: 'Home', label: 'Home' },
  { value: 'Community settings', label: 'Community settings' },
];

export enum PARENT_SN_VERSIONS {
  V1 = 'v1',
  V2 = 'v2',
}

export const SUPERVISION_SETTING_V2 = [{ value: 'Telehealth', label: 'Telehealth' }];

export const GROUP_SN_FIELD_MIN_LENGTH = 120;

export const GROUP_SN_MIN_TOPICS = 1;
export const GROUP_SN_MAX_TOPICS = 10;
export const GROUP_SN_MIN_FAMILIES = 2;
export const GROUP_SN_MAX_FAMILIES = 10;
